export default __webpack_public_path__ + "static/media/sort-numeric-down.ffe3cf2a.svg";